/**
 * DrunkFilterDefs — skrytý SVG `<filter>` pro drunk-mode (heat-distortion).
 *
 * STATICKÝ `feTurbulence` → `feDisplacementMap` (roztavené hrany). Filtr se počítá
 * jen jednou (browser cachuje vrstvu); pohyb („opilecké houpání") obstará levná CSS
 * `transform` animace na `[data-drunk]` kompozitovaná na GPU (viz index.css) — animovat
 * turbulenci CPU každý frame by sekalo. `scale` displacementu (síla roztavení) nastavuje
 * `DrunkModeController` z JS podle intenzity (SVG atribut nečte CSS proměnnou).
 * Aplikuje se přes `filter: url(#bw-drunk-filter)`. Mountuje se jednou v `App`.
 */
export function DrunkFilterDefs() {
  return (
    <svg
      aria-hidden
      focusable="false"
      // Safari/WebKit nevyřeší `filter: url(#…)` na HTML obsahu, když je hostující
      // SVG 0×0 nebo display:none (v Chrome/FF to funguje i tak). Držíme ho proto
      // v render-tree s nenulovou 1×1 velikostí, ale opticky neviditelný.
      style={{
        position: "absolute",
        width: 1,
        height: 1,
        overflow: "hidden",
        opacity: 0,
        pointerEvents: "none",
        left: 0,
        top: 0,
      }}
    >
      <defs>
        <filter
          id="bw-drunk-filter"
          x="-12%"
          y="-12%"
          width="124%"
          height="124%"
          colorInterpolationFilters="sRGB"
        >
          {/* STATICKÝ šum — žádná SMIL animace turbulence (ta přepočítává celé
              Perlinovo pole na CPU každý frame → sekání). Pohyb dělá levná CSS
              transform animace na [data-drunk] (viz index.css), kompozitovaná na
              GPU po filtru. numOctaves=1 = poloviční cena výpočtu. */}
          <feTurbulence type="fractalNoise" baseFrequency="0.012 0.016" numOctaves={1} seed={1} result="noise" />
          {/* scale=0 = bez efektu; controller ho nastaví podle intenzity */}
          <feDisplacementMap
            id="bw-drunk-displace"
            in="SourceGraphic"
            in2="noise"
            scale={0}
            xChannelSelector="R"
            yChannelSelector="G"
          />
        </filter>
      </defs>
    </svg>
  );
}
